import { useEffect, useRef } from "react";
import { barLines, drawPixelBar, drawWatermark, loadAssets } from "@/lib/watermark";

function scene(g, w, h) {
  const grd = g.createLinearGradient(0, 0, w, h);
  grd.addColorStop(0, "#5b6b7a"); grd.addColorStop(1, "#c9b48a");
  g.fillStyle = grd; g.fillRect(0, 0, w, h);
  g.fillStyle = "rgba(255,255,255,0.18)";
  g.fillRect(w * 0.1, h * 0.25, w * 0.35, h * 0.4);
  g.fillStyle = "rgba(0,0,0,0.18)";
  g.beginPath(); g.arc(w * 0.7, h * 0.4, h * 0.18, 0, Math.PI * 2); g.fill();
}

export function WatermarkPreview({ profile }) {
  const ref = useRef(null);
  useEffect(() => {
    let live = true;
    loadAssets(profile).then((assets) => {
      if (!live) return;
      const c = ref.current, w = 960, h = 600;
      c.width = w; c.height = h;
      const g = c.getContext("2d");
      scene(g, w, h);
      if (profile.apply.media) drawWatermark(g, w, h, profile, assets, Math.max(56, Math.round(h * 0.09)));
      drawPixelBar(g, w, h, barLines({ date: new Date(), title: "Sample Note", ref: "REF-1042", profile }));
    });
    return () => { live = false; };
  }, [profile]);
  return <canvas ref={ref} className="w-full rounded-md border" data-testid="watermark-preview-canvas" />;
}
